import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useThemeStore = create(
  persist(
    (set, get) => ({
      theme: 'light',
      toggleTheme: () => {
        const newTheme = get().theme === 'light' ? 'dark' : 'light'
        set({ theme: newTheme })
        
        // Apply theme to document
        const root = document.documentElement
        root.classList.remove('light', 'dark')
        root.classList.add(newTheme)
      },
      setTheme: (theme) => {
        set({ theme })
        const root = document.documentElement
        root.classList.remove('light', 'dark')
        root.classList.add(theme)
      },
    }),
    {
      name: 'theme-storage',
      onRehydrateStorage: () => (state) => {
        if (state?.theme) {
          const root = document.documentElement
          root.classList.remove('light', 'dark')
          root.classList.add(state.theme)
        }
      },
    }
  )
)